const WEIGHTS = [3, 2, 7, 6, 5, 4, 3, 2];

/**
 * A Norwegian organisation number as the backend stores it — nine digits, the spaces an author may
 * type between groups removed — or null when it is not nine digits or its mod-11 check digit (weights
 * 3, 2, 7, 6, 5, 4, 3, 2 over the first eight) does not hold. The same rule as the backend's
 * `TOrganisationNumber.Normalise`; the form checks it first so a typo is caught before anything is
 * sent, and the server's check is still the one that counts.
 */
export const normaliseOrganisationNumber = (typed: string): string | null => {
  const digits = typed.replace(/\s/g, '');
  if (!/^\d{9}$/.test(digits)) return null;

  const sum = WEIGHTS.reduce((total, weight, index) => total + weight * Number(digits[index]), 0);
  const remainder = sum % 11;
  // A remainder of 1 would need a check digit of 10: no number is issued with it.
  if (remainder === 1) return null;
  const check = remainder === 0 ? 0 : 11 - remainder;
  return check === Number(digits[8]) ? digits : null;
};

/** Nine digits as Norwegians write them, in three groups of three: `123 456 789`. Anything else as it is. */
export const groupOrganisationNumber = (orgNumber: string): string => (/^\d{9}$/.test(orgNumber) ? orgNumber.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3') : orgNumber);
